<template>
  <div class="animated fadeInUp">

    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("add") }} {{ $t('email') }} {{ $t('campaign') }}</div>
      <router-link class="btn-blue" :to="{name:'Email Campaigns'}">{{ $t('email') }} {{ $t('campaign') }} {{ $tc("list") }}</router-link>
    </div>

    <div class="white-wrapper pt-0">
      <div class="row border-bottom mb-5 pt-3">
        <div class="col campaign-step" :class="sections.basicInfo ? 'active':''">
          <p :class="sections.basicInfo ? 'font-weight-bold text-blue':''">1.Basic Info</p>
        </div>
        <div class="col campaign-step" :class="sections.message ? 'active':''">
          <p :class="sections.message ? 'font-weight-bold text-blue':''">2.Message</p>
        </div>
        <!--
        <div class="col campaign-step" :class="sections.conversionTracking ? 'active':''">
          <p
            :class="sections.conversionTracking ? 'font-weight-bold text-blue':''"
          >3.Conversion Tracking</p>
        </div>-->

        <div class="col campaign-step" :class="sections.testCampaign ? 'active':''">
          <p :class="sections.testCampaign ? 'font-weight-bold text-blue':''">3.Test Campaign</p>
        </div>

        <div class="col campaign-step" :class="sections.previewAndLauch ? 'active':''">
          <p
            :class="sections.previewAndLauch ? 'font-weight-bold text-blue':''"
          >4.Preview and Launch</p>
        </div>
      </div>

      <!-- BASIC INFO -->
      <div class="col-12 rounded-10 border p-3 mb-4" v-if="sections.basicInfo">
        <div class="row">
          <div class="col-12">
            <div class="section-title text-uppercase mb-3" style="font-size:18px">Basic Info</div>
          </div>
          <div class="col-lg-6 mb-4">
            <div class="input-material">
              <input
                v-validate="'required'"
                name="campaign_name"
                id="campaign_name"
                v-model="campaign_name"
                type="text"
                placeholder="."
              />
              <label>Campaign Name</label>
            </div>
            <p class="error_message">
              <span
                v-if="submitted && errors.has('campaign_name')"
              >{{ errors.first('campaign_name') }}</span>
            </p>
          </div>
          <div class="col-lg-6 mb-4">
            <div class="input-material" v-on:click="selectCampaignTypeModal()">
              <input
                type="text"
                placeholder="."
                v-model="selectedCampaignType.campaign_type_name"
                value="selectedCampaignType"
              />
              <label>Campaign Type</label>
            </div>
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">Select Audience</div>
            <multiselect
              v-model="selected_segment"
              name="campaign_audience"
              id="campaign_audience"
              track-by="segment_name"
              label="segment_name"
              :options="segments"
              v-validate="'required'"
            ></multiselect>
            <p class="error_message">
              <span
                v-if="submitted && errors.has('campaign_audience')"
              >{{ errors.first('campaign_audience') }}</span>
            </p>
            <!-- {{selected_segment}} -->
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">Campaign Start Date</div>
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="campaign_start_date" @click="clearDate('start')">✖</button>
                <Datepicker :monday-first="true"  v-model="campaign_start_date"  typeable/>
                <label :class="campaign_start_date !== '' ? 'active' : ''">Start Date</label>
                <!-- <label v-else>Start Date</label> -->
              </div>

              <p class="error_message">
                <span v-if="submitted && campaign_start_date == ''">{{ 'Please select start date' }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">Campaign End Date</div>

            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="campaign_end_date" @click="clearDate('end')">✖</button>
                <Datepicker :monday-first="true"
                  name="campaign_end_date"
                  id="campaign_end_date"
                  v-model="campaign_end_date"
                  typeable
                />
                <!-- Add class active on date selection -->
                <label :class="campaign_end_date !== '' ? 'active' : ''">End Date</label>
                <!-- <label v-else>End Date</label> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && campaign_end_date == ''">{{ 'Please select end date' }}</span>
                <span v-if="date_checker">{{ 'End Date should be greater than Start Date' }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-12 mb-4">
            <div class="mb-2">Select Content Type</div>
            <b-form-radio-group
              v-model="selected_radio"
              :options="options"
              value-field="item"
              text-field="name"
              disabled-field="notEnabled"
              class="j-radio mb-3"
            ></b-form-radio-group>
            <p class="error_message">
              <span v-if="submitted && selected_radio == ''">{{ 'Please select an option' }}</span>
            </p>
            <!-- <div>
                <span>Promotional (send only to subscribed user in Audience)</span>
            </div>-->

            <!-- <b-form-radio class="j-radio">
              <div>
                <span>Transactional(send to all users in Audience including those who have unsubscribed)</span>
              </div>
            </b-form-radio>-->
          </div>
          <div class="col-lg-6 mb-4">
            <div class="mb-2">Email Template</div>
            <multiselect
              v-model="selected_email_template"
              track-by="et_description"
              label="et_description"
              :options="emailtemplateList"
            ></multiselect>
            <p class="error_message">
              <span
                v-if="submitted && selected_email_template == null"
              >{{ 'Please select an email template' }}</span>
            </p>
          </div>

          <!-- <div class="col-lg-12 mb-4">
            <div class="mb-2">Audience Type</div>
            <b-form-radio class="j-radio mb-3">
              <div>
                <span>Send to users in single sement</span>
              </div>
            </b-form-radio>

            <b-form-radio class="j-radio">
              <div>
                <span>Send to users in multiple segments and/or Don’t send to users in certain segments</span>
              </div>
            </b-form-radio>
          </div>-->

          <!-- <div class="col-lg-12 mb-4">
            <div class="input-material-textarea">
              <textarea v-model="email_message" cols="30" rows="10"></textarea>
              <label class="shift-up">Rechable Users SMS</label>
            </div>
          </div>-->
          <div
            class="col-lg-12 mb-4"
            v-if="selected_email_template && selected_email_template.et_id == 0 && submittedtemplate === false"
          >
            <div class="white-wrapper">
              <div class="row">
                <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                  <div class="input-material">
                    <input
                      v-model="email_temp_name"
                      v-validate="'required'"
                      placeholder="."
                      type="text"
                      name="emailtemplatename"
                      id="emailtemplatename"
                    />
                    <label>{{ $t('emailtemplate') }} {{ $t('name') }}</label>
                  </div>
                  <p v-if="submitted3 && email_temp_name == ''" class="error_message">
                    <span>{{ "Please enter Email Template Name" }}</span>
                  </p>
                </div>

                <div class="col-lg-12 align-self-center mb-4">
                  <div class="input-material">
                    <input
                      v-model="email_title"
                      v-validate="'required'"
                      placeholder="."
                      type="text"
                      name="emailtitle"
                      id="emailtitle"
                    />
                    <label>{{ $t('email') }} {{ $t('title') }}</label>
                  </div>
                  <p v-if="submitted3 && email_title == '' " class="error_message">
                    <span>{{ "Please enter Email Name"}}</span>
                  </p>
                </div>

                <div class="col-lg-12 align-self-center mb-4">
                  <vue-editor v-model="email_template_content"></vue-editor>
                  <p v-if="submitted3 && email_template_content == '' " class="error_message">
                    <span>{{ "Please create a template"}}</span>
                  </p>
                </div>

                <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                  <div class="row">
                    <div class="col-md-3 col-xl-2">
                      <label>{{ $t('active') }}</label>
                    </div>
                    <div class="col-md-9 col-xl-10">
                      <div class="col-4">
                        <b-form-checkbox
                          class="ml-4"
                          v-model="email_temp_is_active"
                          switch
                          name="check-button"
                        ></b-form-checkbox>
                      </div>
                    </div>
                  </div>
                  <p class="error_message">
                    <span></span>
                  </p>
                </div>
                <div class="col-md-12 text-center mt-4">
                  <button @click.prevent.stop="OnFinalSubmit()" class="btn-blue">{{ $t('save') }}</button>
                  <button @click.prevent.stop="onResetForm" class="btn-black">{{ $t('reset') }}</button>
                  <!-- <b-button
                    class="btn-outline-grey"
                    variant="default"
                    to="email-template"
                  >{{ $t('cancel') }}</b-button>-->
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-12 text-center">
            <button @click="onSaveBasicInfo()" class="btn btn-blue">Save and Continue</button>
          </div>
        </div>
      </div>

      <!-- 02 MESSAGE -->
      <div class="col-12 rounded-10 border p-3 mb-4" v-if="sections.message">
        <div class="row">
          <div class="col-12">
            <div class="section-title text-uppercase mb-3" style="font-size:18px">Message</div>
          </div>

          <div class="col-12 mb-4">
            <div class="rounded">
              <h6>Personalizing Content in Transactional Campaigns</h6>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto dolor quod rerum temporibus dicta vero voluptates sint quia aspernatur inventore? Ex, aut! Beatae dolor in, neque veniam consequuntur exercitationem unde. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus fugiat saepe consequuntur, ipsum nulla incidunt atque eos tempora odit voluptatum sint illum quaerat! In aliquam error laudantium blanditiis delectus similique.</p>
            </div>
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">Email Service Provider</div>
            <!-- <custommultiselect
              :options="arr"
              v-model="selected"
              placeholder="Sent To"
              label="cine_name"
              isSingleId="cine_id"
            ></custommultiselect>-->
            <!-- <select  @change="onChange($event)"> -->
            <multiselect
              v-model="selected_email_provider"
              name="email_provider"
              id="email_provider"
              track-by="ep_name"
              label="ep_name"
              :options="email_providers"
            ></multiselect>
            <p class="error_message">
              <span
                v-if="submitted2 && selected_email_provider == null"
              >{{ 'Please select email provider' }}</span>
            </p>
            <!-- {{selected_email_provider}} -->
            <!-- <option
                v-for="(singleEmailProvider, providerIndex) in email_providers"
                :key="providerIndex"
                :value="singleEmailProvider.ep_id"
              >{{singleEmailProvider.ep_name}}</option>
            </select>-->
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">Email Sender</div>
            <!-- <custommultiselect
              :options="selectUsers"
              placeholder="Select Sender"
              label="cine_name"
              isSingleId="cine_id"
            ></custommultiselect>-->
            <multiselect
              v-model="selected_email_sender"
              name="selected_email_sender"
              id="selected_email_sender"
              label="es_name"
              track-by="es_name"
              :options="email_senders"
            ></multiselect>
            <p class="error_message">
              <span
                v-if="submitted2 && selected_email_sender == null"
              >{{ "Please select email sender" }}</span>
            </p>
            <!-- {{selected_email_sender}} -->
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">Delivery Time </div>
            <div class="d-flex">
              <b-form-radio-group
                class="j-radio mb-3 mr-3"
                v-model="selected_radio_delivery"
                :options="optionsDelivery"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
              ></b-form-radio-group>
              <!-- <b-form-radio class="j-radio mb-3">
                <div>Later</div>
              </b-form-radio>-->
            </div>
            <p class="error_message">
              <span
                v-if="submitted2 && selected_radio_delivery == ''"
              >{{ 'Please select an option' }}</span>
            </p>
          </div>
          <div class="col-lg-4 mb-4">
            <div v-if="selected_radio_delivery !=='Now'" class="mb-2">Delivery Time and Date</div>
            <div v-if="selected_radio_delivery !== 'Now'" class="input-material">
              <div class="add-datepicker">
                <!-- <datetime
                  v-model="delivery_datetime"
                  type="datetime"
                  class="theme-custom-date-time"
                  format="yyyy-MM-dd hh:mm:ss a"
                  use12-hour
                ></datetime> -->
                <button
                  v-if="delivery_datetime"
                  v-on:click="clearDate('delivery_datetime')"
                  class="btn-clearDate"
                >✖</button>
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  v-model="delivery_datetime"
                  type="date"
                  class="theme-custom-date-time"
                  typeable
                  id="fromd"
                  name="fromd"
                  :disabled-dates="disabledDates"
                ></Datepicker>
                <!-- <label v-if="delivery_datetime === ''">Select Date and Time</label> -->
              </div>
              <p class="error_message">
                <span
                  v-if="submitted2 && delivery_datetime == ''"
                >{{ 'Please select Date and Time' }}</span>
              </p>
            </div>
            <!-- <div class="row">
              <div class="col-lg-2">
                <custommultiselect
                  :options="selectUsers"
                  placeholder="Weekly"
                  label="cine_name"
                  isSingleId="cine_id"
                ></custommultiselect>
              </div>

              <div class="col-lg-3">
                <div class="d-flex align-items-center w-100">
                  <custommultiselect
                    :options="selectUsers"
                    placeholder="Sunday"
                    label="cine_name"
                    isSingleId="cine_id"
                  ></custommultiselect>
                  <div class="ml-3">on</div>
                </div>
              </div>

              <div class="col-lg-2">
                <div class="d-flex align-items-center w-100">
                  <custommultiselect
                    :options="selectUsers"
                    placeholder="11"
                    label="cine_name"
                    isSingleId="cine_id"
                  ></custommultiselect>
                  <div class="ml-3">:</div>
                </div>
              </div>

              <div class="col-lg-2">
                <div class="d-flex align-items-center w-100">
                  <custommultiselect
                    :options="selectUsers"
                    placeholder="30"
                    label="cine_name"
                    isSingleId="cine_id"
                  ></custommultiselect>
                </div>
              </div>

              <div class="col-lg-2">
                <div class="d-flex align-items-center w-100">
                  <custommultiselect
                    :options="selectUsers"
                    placeholder="AM"
                    label="cine_name"
                    isSingleId="cine_id"
                  ></custommultiselect>
                </div>
              </div>
            </div>-->
          </div>
          <div class="col-lg-2 mb-4">
            <div v-if="selected_radio_delivery !=='Now'" class="mb-2">Time</div>
            <div v-if="selected_radio_delivery !== 'Now'" class="input-material">
              <div class="add-datepicker custom-timepicker">
                <vue-timepicker
                  manual-input
                  v-model="startTime2"
                  id="starttime"
                  name="starttime"
                  placeholder="Start Time"
                  format="HH:mm"
                  class="time_picker"
                  input-width="100%"
                  auto-scroll
                  lazy
                  @change="onChangeTime"
                ></vue-timepicker>
              </div>
              <p class="error_message">
                <span
                  v-if="submitted2 && selected_radio_delivery !== 'Now' && startTime2 == ''"
                >{{ 'Please Select Time' }}</span>
              </p>
            </div>
          </div>

          <!-- <div class="col-lg-6 mb-4">
            <div class="mb-2">DND</div>
            <div class="text-blue c-pointer small">SET DND HOURS</div>
          </div>-->

          <!-- <div class="col-lg-12 mb-4">
            <div class="mb-2">Throttling</div>
            <b-form-radio class="j-radio mb-4">
              <div>Do not throttle campaigns. Send all message immediately</div>
            </b-form-radio>

            <b-form-radio class="j-radio mb-3">
              <div>Throttle campaigns as per channel throttling limits</div>
            </b-form-radio>

            <div class="d-flex align-items-center">
              <b-form-radio class="j-radio">
                <div class="text-nowrap">Throttle campaigns at</div>
              </b-form-radio>
              <div class="input-material mx-2" style="width:100px">
                <input type="text" />
              </div>
              <div>message per minute</div>
            </div>
          </div>-->

          <div class="col-lg-6 align-self-center">
            <router-link to @click.native="onBackFromMessages()">Back</router-link>
          </div>

          <div class="col-lg-6 text-right">
            <button @click="onSaveMessage()" class="btn btn-blue">Save and Continue</button>
          </div>
        </div>
      </div>

      <!-- 03 CONVERSION TRACKING -->
      <div class="col-12 rounded-10 border p-3 mb-4" v-if="sections.conversionTracking">
        <div class="row">
          <div class="col-12">
            <div
              class="section-title text-uppercase mb-3"
              style="font-size:18px"
            >Conversion Tracking</div>
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">Converstion Event</div>
            <custommultiselect
              :options="selectUsers"
              placeholder="Select an Event"
              label="cine_name"
              isSingleId="cine_id"
            ></custommultiselect>
          </div>

          <div class="col-lg-6">
            <div class="mb-3">Enable conversion Tracking</div>
            <b-form-checkbox unchecked-value="N" value="Y" name="check-button" switch></b-form-checkbox>
          </div>

          <div class="col-lg-12 mb-4">
            <div class="mb-2">Converstion Deadline</div>
            <div class="row">
              <div class="col-2">
                <div class="input-material">
                  <input type="text" placeholder="." />
                  <label></label>
                </div>
              </div>
              <div class="col-2">
                <custommultiselect
                  :options="selectUsers"
                  placeholder="Months"
                  label="cine_name"
                  isSingleId="cine_id"
                ></custommultiselect>
              </div>
              <div class="col-4 align-self-center">from delivery of message to user</div>
            </div>
          </div>

          <div class="col-12">
            <div class="mb-2">Control group(CG)</div>
            <b-form-checkbox class="j-checkbox mb-3">
              <div class="text-capitalize">Add a control to measure effectiveness of campaign</div>
            </b-form-checkbox>
          </div>

          <div class="col-lg-12 mb-4">
            <div class="mb-2">Throttling</div>
            <b-form-radio class="j-radio mb-4">
              <div>Do not throttle campaigns. Send all message immediately</div>
            </b-form-radio>

            <b-form-radio class="j-radio mb-3">
              <div>Throttle campaigns as per channel throttling limits</div>
            </b-form-radio>

            <div class="d-flex align-items-center">
              <b-form-radio class="j-radio">
                <div class="text-nowrap">Throttle campaigns at</div>
              </b-form-radio>
              <div class="input-material mx-2" style="width:100px">
                <input type="text" />
              </div>
              <div>message per minute</div>
            </div>
          </div>

          <div class="col-lg-6 align-self-center">
            <router-link to @click.native="onBackFromConversionTracking()">Back</router-link>
          </div>

          <div class="col-lg-6 text-right">
            <button @click="onSaveConversionTracking()" class="btn btn-blue">Save and Continue</button>
          </div>
        </div>
      </div>

      <!-- 04 TEST CAMPAIGN -->
      <div class="col-12 rounded-10 border p-3 mb-4" v-if="sections.testCampaign">
        <div class="row">
          <div class="col-12">
            <div class="section-title text-uppercase mb-3" style="font-size:18px">Test Campaign</div>
            <div>
              Campaign Name:&nbsp;{{campaign_name}}
              <br />
              Campaign Type:&nbsp;{{selectedCampaignType.campaign_type_name}}
              <br />
              Audience:&nbsp;{{selected_segment.segment_name}}
              <br />
              Campaign Start Date:&nbsp;{{start_date}}
              <br />
              Campaign End Date:&nbsp;{{end_date}}
              <br />
              Content Type:&nbsp;{{selected_radio}}
              <br />
              Email Template:&nbsp;{{selected_email_template.et_description}}
              <br />
              Email Service Provider:&nbsp;{{selected_email_provider.ep_name}}
              <br />
              Email Sender:&nbsp;{{selected_email_sender.es_name}}
              <br />
              Delivery Date and Time:&nbsp;{{show_delivery_date_time}}
              <br />
              Delivery Time:&nbsp;{{selected_radio_delivery}}
              <br />
            </div>
          </div>
          <div class="col-lg-6 align-self-center">
            <router-link to @click.native="onBackFromTestCampaign()">Back</router-link>
          </div>

          <div class="col-lg-6 text-right">
            <button @click="onSaveTestCampaign()" class="btn btn-blue">Save and Continue</button>
          </div>
        </div>
      </div>

      <!-- 05 PREVIEW AND LAUNCH -->
      <div class="col-12 rounded-10 border p-3 mb-4" v-if="sections.previewAndLauch">
        <div class="row">
          <div class="col-12">
            <div class="section-title text-uppercase mb-3" style="font-size:18px">Preview and Launch</div>
          </div>
          <div class="col-lg-6 align-self-center">
            <router-link to @click.native="onBackFromPreviewAndLaunch()">Back</router-link>
          </div>

          <div class="col-lg-6 text-right">
            <button @click="onSavePreviewAndLaunch()" class="btn btn-blue">Save and Continue</button>
          </div>
        </div>
      </div>
    </div>

    <!-- SELECT CAMPAIGN TYPE MODAL -->
    <b-modal
      size="lg"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      id="selectCampaignType"
      ref="selectCampaignType"
      :title="$t('select') + ' ' + $t('campaign') + ' ' + $t('type')"
    >
      <div class="row">
        <!-- <div class="col-12">
          <div class="text-center mb-4">
            <h5>Select Campaign Type</h5>
          </div>
        </div> -->
        <div
          v-for="(campaigntype, campaigntypeIndex) in campaign_types"
          :key="campaigntypeIndex"
          class="col-lg-3"
        >
          <div
            class="border text-center rounded p-3 h-100 c-pointer border-blue-hover"
            v-on:click="onSelectCampaignType(campaigntype)"
          >
            <h6>{{campaigntype.campaign_type_name}}</h6>
            <p class="small mb-0">{{campaigntype.campaign_type_desc}}</p>
          </div>
        </div>
        <!-- <div class="col-lg-3">
          <div
            class="border text-center rounded p-3 h-100 c-pointer border-blue-hover"
            v-on:click="onSelectCampaignType('Triggered')"
          >
            <h6>Triggered</h6>
            <p class="small p-0">Send the campaign on the occurrence of a custom event</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div
            class="border text-center rounded p-3 h-100 c-pointer border-blue-hover"
            v-on:click="onSelectCampaignType('Recurring')"
          >
            <h6>Recurring</h6>
            <p class="small mb-0">Schedule the campaign to be sent at regular intervals</p>
          </div>
        </div>
        <div class="col-lg-3 text-center" v-on:click="onSelectCampaignType('Transactional')">
          <div class="border text-center rounded p-3 h-100 c-pointer border-blue-hover">
            <h6>Transactional</h6>
            <p class="small mb-0">Send critical messages throughout the transactional API</p>
          </div>
        </div>-->
      </div>
    </b-modal>
  </div>
</template>

<script>
import MarketingAutomation from "@/services/MarketingAutomationService";
import moment from "moment";
import { VueEditor } from "vue2-editor";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: {
    VueEditor, VueTimepicker},
  data() {
    return {
      submitted3: false,
      email_template_insert_id: 0,
      keys: [],
      submittedtemplate: false,
      email_temp_is_active: true,
      email_template_content: "",
      email_temp_name: "",
      email_title: "",
      selected_email_template: null,
      date_checker: false,
      submitted2: false,
      submitted: false,
      ec_id: 0,
      campaign_details: "",
      campaign_types: [],
      email_providers: [],
      selected_email_provider: {
        ep_id: 0,
        ep_name: ""
      },
      email_senders: [],
      selected_email_sender: {
        es_id: 0,
        es_name: ""
      },
      segments: [],
      selected_segment: {
        s_id: 0,
        segment_name: ""
      },
      campaign_name: "",
      campaign_start_date: "",
      campaign_end_date: "",

      options: [
        {
          item: "Promotional",
          name: "Promotional (send only to subscribed user in Audience)"
        },
        {
          item: "Transactional",
          name:
            "Transactional(send to all users in Audience including those who have unsubscribed)"
        }
      ],
      selected_radio: "",
      delivery_datetime: "",
      optionsDelivery: [
        {
          item: "Now",
          name: "Now"
        },
        {
          item: "Later",
          name: "Later"
        }
      ],
      selected_radio_delivery: "",
      sections: {
        basicInfo: true,
        message: false,
        conversionTracking: false,
        testCampaign: false,
        previewAndLauch: false
      },
      selectedCampaignType: {
        campaign_type_name: "",
        ct_id: 0
      },
      selectUsers: ["All Users", "Selected Users"],
      token: 0,
      emailtemplateList: [],
      startTime2: "",
      disabledDates: {
      to: new Date(Date.now() - 8640000),
    },
    };
  },
  watch: {
    selected_radio_delivery: function(newVal) {
      if (newVal == "Now") {
        this.delivery_datetime = moment().format("YYYY-MM-DD HH:mm:ss");
      }
    },
    campaign_start_date: function(newVal) {
      console.log("newVal :", newVal);
      if (newVal) {
        let start = moment(this.campaign_start_date).format();
        let end = moment(this.campaign_end_date).format();
        if (start > end) {
          this.date_checker = true;
        } else {
          this.date_checker = false;
        }
      }
    },
    campaign_end_date: function(newVal) {
      if (newVal) {
        if (this.campaign_start_date !== "") {
          let start = moment(this.campaign_start_date).format();
          let end = moment(this.campaign_end_date).format();
          if (start < end) {
            this.date_checker = false;
          } else {
            this.date_checker = true;
          }
        }
      }
    }
  },
  computed: {
    start_date() {
      return moment(this.campaign_start_date).format("MMMM Do YYYY");
    },
    end_date() {
      return moment(this.campaign_end_date).format("MMMM Do YYYY");
    },
    show_delivery_date_time() {
      return moment(this.delivery_datetime, "YYYY-MM-DD HH:mm:ss").format(
        "MMMM Do YYYY,  h:mm:ss a "
      );
    }
  },
  methods: {
    clearDate(type) {
      if(type == 'start') {
        this.campaign_start_date = ""
      } else if(type == 'end') {
        this.campaign_end_date = ""
      } else if(type == 'delivery_datetime') {
        this.delivery_datetime = ""
      }
    },
    convertTime(date, time) {
      const d = moment(date).format("YYYY-MM-DD");
      const newdate = moment(d + " " + time).format('YYYY-MM-DD HH:mm');
      return newdate
    },
    onChangeTime(event) {
      console.log("this.delivery_datetime", this.delivery_datetime);
      if(!this.delivery_datetime) {
        return this.$toasted.show('Please Select Date')
      }
      this.delivery_datetime = this.convertTime(this.delivery_datetime, this.startTime2)
      console.log("this.delivery_datetime", this.delivery_datetime);
    },
    OnFinalSubmit: function() {
      console.log("coming here :");
      this.submitted3 = true;

      if (
        this.email_temp_name !== "" &&
        this.email_title !== "" &&
        this.email_template_content !== ""
      ) {
        let payload = {
          description: this.email_temp_name,
          subject: this.email_title,
          content: this.email_template_content,
          is_et_active: this.email_temp_is_active
        };

        MarketingAutomation.AddEmailTemplate(payload)
          .then(response => {
            const { data } = response;

            if (data && data.status) {
              this.submittedtemplate = true;
              this.submitted3 = false;
              this.email_template_insert_id = data.Records;
              this.$toasted.show("Template added and selected successfully");

              // this.$router.push({
              //   path: "/master/email-template"
              // });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      } else {
        this.$toasted.show("Enter all template details");
      }
    },
    getEmailTemplateList: function() {
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage
      };
      MarketingAutomation.GetEmailTemplates()
        .then(response => {
          const { data } = response;

          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.emailtemplateList = data.Records;
              this.emailtemplateList.push({
                et_description: "Custom Template",
                et_id: 0
              });
              console.log("this.emailtemplateList :", this.emailtemplateList);
            } else {
              this.emailtemplateList.push({
                et_description: "Custom Template",
                et_id: 0
              });
            }
          }
        })
        .catch(this._CatchError);
    },
    getCampaignTypes() {
      MarketingAutomation.getCampaignTypes()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            console.log("mydata :", data);
            this.campaign_types = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getEmailProviders() {
      MarketingAutomation.getEmailProviders()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.email_providers = data.Records;

            console.log("this.email_providers :", this.email_providers);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getEmailSenders() {
      MarketingAutomation.getEmailSenders()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.email_senders = data.Records;

            console.log("this.email_senders :", this.email_senders);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getSegments() {
      MarketingAutomation.getSegments()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.segments = data.Records;

            console.log("this.segments :", this.segments);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    addCampaign() {
      MarketingAutomation.addCampaign({
        campaign_name: this.campaign_name,
        campaign_type_id: this.selectedCampaignType.ct_id,
        segment_id: this.selected_segment.s_id,
        campaign_start_date: this.campaign_start_date,
        campaign_end_date: this.campaign_end_date,
        content_type: this.selected_radio,

        ep_id: this.selected_email_provider.ep_id,
        es_id: this.selected_email_sender.es_id,
        delivery: this.selected_radio_delivery,
        delivery_datetime: this.delivery_datetime
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    addCampaignBasic(payload) {
      let et_id = payload;
      MarketingAutomation.addCampaignBasic({
        token: this.token,
        campaign_name: this.campaign_name,
        campaign_type_id: this.selectedCampaignType.ct_id,
        segment_id: this.selected_segment.s_id,
        campaign_start_date: this.campaign_start_date,
        campaign_end_date: this.campaign_end_date,
        content_type: this.selected_radio,
        et_id: et_id
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            // this.$toasted.show(data.message);
            this.sections.basicInfo = false;
            this.sections.message = true;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    updateCampaignMessage() {
      MarketingAutomation.updateCampaignMessage({
        token: this.token,
        ep_id: this.selected_email_provider.ep_id,
        es_id: this.selected_email_sender.es_id,
        delivery: this.selected_radio_delivery,
        delivery_datetime: this.delivery_datetime
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            // this.$toasted.show(data.message);
            this.sections.message = false;
            this.sections.testCampaign = true;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    finalAddCampaign() {
      MarketingAutomation.finalAddCampaign({
        token: this.token
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show(data.message);
            this.$router.push({ name: "Email Campaigns" });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getAddCampaignDetails(payload) {
      MarketingAutomation.getAddCampaignDetails({ token: payload.token })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.campaign_details = data.Records[0];
            console.log("this.campaign_details :", this.campaign_details);
            this.campaign_name = this.campaign_details.campaign_name;
            this.selectedCampaignType.campaign_type_name = this.campaign_details.campaign_type_name;
            this.selectedCampaignType.ct_id = this.campaign_details.ct_id;
            this.selected_segment.segment_name = this.campaign_details.segment_name;
            this.selected_segment.s_id = this.campaign_details.s_id;
            this.campaign_start_date = this.campaign_details.campaign_start_date;
            this.campaign_end_date = this.campaign_details.campaign_end_date;
            this.selected_email_template = {
              et_id: this.campaign_details.et_id,
              et_description: this.campaign_details.et_description
            };

            if (this.campaign_details.ep_id !== null) {
              this.selected_email_provider.ep_id = this.campaign_details.ep_id;
              this.selected_email_provider.ep_name = this.campaign_details.ep_name;
            } else {
              this.selected_email_provider = null;
              console.log(
                " this.selected_email_provider:",
                this.selected_email_provider
              );
            }
            if (this.campaign_details.es_id !== null) {
              this.selected_email_sender.es_id = this.campaign_details.es_id;
              this.selected_email_sender.es_name = this.campaign_details.es_name;
            } else {
              this.selected_email_sender = null;
            }

            if (this.campaign_details.date_time) {
              this.delivery_datetime = moment
                .unix(this.campaign_details.date_time)
                .format();
            }

            if (this.campaign_details.is_promotional == "Y") {
              this.selected_radio = "Promotional";
            } else {
              this.selected_radio = "Transactional";
            }
            if (this.campaign_details.is_send_now !== null) {
              if (this.campaign_details.is_send_now == "Y") {
                this.selected_radio_delivery = "Now";
              } else {
                this.selected_radio_delivery = "Later";
              }
            }
            if (this.selectedCampaignType.campaign_type_name == null) {
              this.$refs["selectCampaignType"].show();
            }
          } else {
            this.selected_segment = null;
            this.selected_email_sender = null;
            this.selected_email_provider = null;

            this.$refs["selectCampaignType"].show();

            // this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onSelectCampaignType(selection) {
      this.selectedCampaignType = selection;
      this.$refs["selectCampaignType"].hide();
    },
    selectCampaignTypeModal() {
      this.$refs["selectCampaignType"].show();
    },
    onSaveBasicInfo() {
      this.submitted = true;
      this.$validator.validate().then(async valid => {
        if (
          valid &&
          this.campaign_start_date !== "" &&
          this.campaign_end_date !== "" &&
          this.selected_radio !== "" &&
          this.selected_email_template &&
          this.campaign_end_date > this.campaign_start_date
        ) {
          if (this.selected_email_template.et_id !== 0) {
            await this.addCampaignBasic(this.selected_email_template.et_id);
          } else if (
            this.selected_email_template.et_id == 0 &&
            this.email_template_insert_id !== 0
          ) {
            //code here
            await this.addCampaignBasic(this.email_template_insert_id);
          } else {
            this.$toasted.show("Please create the custom template");
          }
        } else {
          this.$toasted.show("Please enter all details");
        }
      });
    },
    onSaveMessage: function() {
      this.submitted2 = true;
      if (
        this.selected_email_provider !== null &&
        this.selected_email_sender !== null &&
        this.selected_radio_delivery != ""
      ) {
        if (this.selected_radio_delivery == "Now") {
          this.updateCampaignMessage();
        } else {
          if (this.delivery_datetime !== "") {
            this.updateCampaignMessage();
          } else {
            this.$toasted.show("Please select delivery date and time");
          }
        }
      } else {
        this.$toasted.show("Please enter all details");
      }
      // this.sections.message = false;
      // this.sections.testCampaign = true;
      // this.sections.conversionTracking = true;
    },
    onSaveConversionTracking: function() {
      this.sections.conversionTracking = false;
      this.sections.testCampaign = true;
    },
    onSaveTestCampaign: function() {
      this.sections.testCampaign = false;
      this.sections.previewAndLauch = true;
    },
    onBackFromMessages: function() {
      this.sections.message = false;
      this.sections.basicInfo = true;
    },
    onBackFromConversionTracking: function() {
      this.sections.conversionTracking = false;
      this.sections.message = true;
    },
    onBackFromTestCampaign: function() {
      this.sections.testCampaign = false;
      // this.sections.conversionTracking = true;
      this.sections.message = true;
    },
    onBackFromPreviewAndLaunch: function() {
      this.sections.previewAndLauch = false;
      this.sections.testCampaign = true;
    },
    onSavePreviewAndLaunch: function() {
      // this.sections.testCampaign = false;
      // this.sections.previewAndLauch = true;
      this.finalAddCampaign();
    }
  },
  beforeMount() {
    const { token } = this.$route.params;
    if (token) {
      this.token = token;
      console.log("this.token :", this.token);
      this.getAddCampaignDetails({ token: token });
    }
  },

  mounted() {
    // this.onRefresh();
    this.getEmailTemplateList();
    this.getCampaignTypes();
    this.getEmailProviders();
    this.getEmailSenders();
    this.getSegments();
    // if (this.selectedCampaignType.campaign_type_name == "") {
    //   this.$refs["selectCampaignType"].show();
    // }
  }
};
</script>

<style>
.campaign-step {
  width: 100%;
  text-align: center;
  position: relative;
  border-bottom: 3px solid transparent;
}

.campaign-step:not(:last-child)::after {
  top: -5px;
  right: -12.5px;
  content: "→";
  display: block;
  font-size: 20px;
  position: absolute;
}

.campaign-step.active {
  border-color: var(--blue);
}

.custom-control {
  padding-left: 0px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingAutomationContainer/EmailComponents/addEmailCampaign.vue